import ColorsTemplate from './ColorsTemplate'

export * from './ColorsTemplate'

export default ColorsTemplate
